import { ForwardedRef, forwardRef } from "react";
import styles from "./BvnOptionArea.module.scss";
import useForwardRef from "../../../../hooks/useForwardRef";
import BvnOptionButton from "./BvnOptionButton/BvnOptionButton";
import { InitiateLookupDataMethods } from "../../../../stores/slices/customer-registration-slice";

export type RadioButtonOption = {
	key: any;
	label: string;
	value: any;
};

type Props = {
	initialValue?: string;
	methods?: InitiateLookupDataMethods[];
	onChange: (value: InitiateLookupDataMethods) => void;
	onPhoneNumberChange: (phoneNumber: string) => void;
};

const BvnOptionArea = forwardRef((props: Props, ref: ForwardedRef<HTMLInputElement>) => {
	const { onChange, onPhoneNumberChange, initialValue, methods } = props;
	const forwardedRef = useForwardRef(ref);

	const handleContainerClick = () => {
		if (forwardedRef?.current) {
			forwardedRef.current.focus();
		}
	};

	return (
		<button type="button" className={`${styles.inputContainer} `} onClick={handleContainerClick}>
			<div className={styles.inputContent}>
				<div className={styles.optionsContainer}>
					{methods?.map((x, i) => (
						<BvnOptionButton
							key={`${i}-id`}
							number={i + 1}
							initialValue={initialValue}
							onChangePhoneNumber={onPhoneNumberChange}
							onChangeValue={onChange}
							method={x}
						/>
					))}
				</div>
			</div>
		</button>
	);
});

export default BvnOptionArea;
